const JEM_VIEW_MODES = {
  singleTask: 0,
  taskList: 1,
};

const jemViewModeKey = 'jem-view-mode';

export default {
  JEM_VIEW_MODES,
  jemViewModeKey,
};

export { JEM_VIEW_MODES, jemViewModeKey };
